import React ,{ useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Footer from './components/footer/Footer';
import About from './components/about/About';
import Header from './components/header/Header';
import Experience from "./components/experience/Experience";
import Portfolio from "./Portfoliooo/Portfolio";
import ScrollReveal from 'scrollreveal';

function App() {

  useEffect(() => {
    const reveal = ScrollReveal();
    const home = () => {
      reveal.reveal('.my', {
        duration: 1000,
        delay: 400,
        distance: '60px',
        easing: 'ease-in-out',
        origin: 'top',
        reset: true,
      });
  
      reveal.reveal('.image', {
        duration: 1000,
        delay: 400,
        distance: '60px',
        easing: 'ease-in-out',
        origin: 'bottom',
        reset: true,
      });
    }

    reveal.reveal('.slider', {
      duration: 1000,
      delay: 400,
      distance: '60px',
      easing: 'ease-in-out',
      origin: 'top',
      reset: true,
    });

    reveal.reveal('.proex', {
      duration: 1000,
      delay: 400,
      distance: '60px',
      easing: 'ease-in-out',
      origin: 'bottom',
      reset: true,
    });

    reveal.reveal('.image2', {
      duration: 1000,
      delay: 400,
      distance: '60px',
      easing: 'ease-in-out',
      origin: 'left',
      reset: true,
    });

    reveal.reveal('.text', {
      duration: 1000,
      delay: 400,
      distance: '60px',
      easing: 'ease-in-out',
      origin: 'right',
      reset: true,
    });

    reveal.reveal('.corcess', {
      duration: 1000,
      delay: 400,
      distance: '60px',
      easing: 'ease-in-out',
      origin: 'right',
      reset: true,
    });

    home();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header/>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/experience" element={<Experience />} />
          <Route exact path="/portfolio" element={<Portfolio />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
